import loadable from "@loadable/component";

export const IntegratedEcoConsumptionSection = loadable(async () => {
    const component = await import(
        /* webpackChunkName: "integrated-eco-consumption-section" */
        /* webpackPreFetch: true */
        "./EcoConsumptionSection"
    );
    return component.default;
});
